<template lang="pug">
  section
    v-text-field(
      readonly
      v-model="p_label"
      label="タリフ"
      append-outer-icon="search"
      @click:append-outer="openDialog"
      :error-messages="errorHandlerMethod(errorHandlerMethodArgComputed)")

    PagingMasterSelectDialog(ref="dialog" v-on:select:record="selectItem"
      :config="config" :initSearchCond="initSearchCond" :getListActionName="'tariff/fetchAllUsable'")
      template(v-slot:body="{body}")
        td.text-xs-left {{ body.tariffCd }}
        td.text-xs-left {{ body.tariffName }}
        td.text-xs-left {{ body.tariffTagNameDisplay }}
</template>

<script>
import ApiHandler from "@/mixin/ApiHandler";
import MasterSelectDialog from "@/mixin/MasterSelectDialog";
import PagingMasterSelectDialog from "@/components/common/PagingMasterSelectDialog";

export default {
  components: { PagingMasterSelectDialog },
  mixins: [ApiHandler, MasterSelectDialog],
  data() {
    return {
      defaultErrorHandlerMethodArg: "tariffId",
      config: {
        title: "タリフ選択",
        headers: [
          {
            text: "タリフCD",
            key: "tariffCd",
            align: ""
          },
          {
            text: "タリフ名",
            key: "tariffName",
            align: ""
          },
          {
            text: "タグ名",
            key: "tagName",
            align: ""
          }
        ],
        width: "50%"
      },
      initSearchCond: () => {
        return {
          tariffCd: "",
          tariffName: "",
          tagName: "",
          activeFilter: true
        };
      }
    };
  },
  methods: {
    //名称のフィールド名(code)が異なるのでオーバーライド
    //タリフコードを選択
    selectItem(data) {
      let isChanged = this.p_code !== data.tariffCd;
      this.p_code = data.tariffCd;
      this.p_label = data.tariffName;
      if (isChanged) this.$emit("changeItem");
    }
  }
};
</script>
